import { useState, FC, memo, useEffect, useMemo } from 'react';

import { IonApp, IonContent, IonFooter, IonHeader, IonProgressBar, IonTitle, IonToolbar, useIonAlert } from '@ionic/react';

/* My Components */
import { StepperRegister } from './StepperRegister';

import { useHistory, useLocation } from 'react-router-dom';

import { BarrLoaderSpiner } from '../../components/BarrLoaderSpiner';

import useAxios, { configure } from 'axios-hooks';

import configData from "../../config.json";

import Axios from 'axios';

import './style.css';

const apiUrl = (process.env.NODE_ENV !== 'development') ? configData.EndPoint : configData.EndPointLocal;

const axios = Axios.create({
  baseURL: apiUrl
});

configure({ axios });

const useQuery = () => {
  const { search } = useLocation();
  return useMemo(() => new URLSearchParams(search), [search]);
};

const AutoRegister: FC = (): JSX.Element => {

  const query = useQuery();

  const cupon: any = query.get("cupon");  // cupon de descuento

  const history = useHistory();
  const [present] = useIonAlert();

  const [showSpinner, setShowSpinner] = useState(true as boolean);

  const barrLoaderProps: any = {
    spinnerState: { showSpinner, setShowSpinner },
  };

  const [{ data: getData, loading: getLoading, error: getError }, executeGet] = useAxios(
    {
      url: `index.php/Cupones/validate/?codigo=${cupon}`,
      method: 'GET'
    },
    { manual: true }
  );

  useEffect(() => {
    if (!cupon) return
    executeGet().then(({ data: { type, message } }) => present({
      header: type === 'error' ? 'Cupón inválido.' : 'Cupón válido.',
      message,
      buttons: [{ text: 'Ok' }],
      onDidDismiss: (e) => type === 'error' ? history.replace('/') : '',
    }));
  }, []);

  if (getLoading) return (
    <>
      <BarrLoaderSpiner {...barrLoaderProps} />
      <IonProgressBar type="indeterminate"></IonProgressBar>
    </>);

  if (getError) return <p>Error!</p>;

  return (
    <IonApp>
      <IonHeader>
        <IonToolbar>
          <IonTitle>
            Registra tu institución
          </IonTitle>{" "}
        </IonToolbar>
      </IonHeader>

      <IonContent fullscreen={true}>
        <StepperRegister />
      </IonContent>

      <IonFooter className="ion-no-border" style={{ textAlign: 'center' }}>
        <IonToolbar style={{ textAlign: 'center' }} color="primary">
          <IonTitle>
            <a href="https://kidkiriki.com/" style={{ textDecoration: 'none', color: 'white' }}>KIDKIRIKI</a>
          </IonTitle>
        </IonToolbar>
      </IonFooter>
    </IonApp>
  );
};

export default memo(AutoRegister);
